'use strict';

function UserAvatarService($resource, config) {
  return $resource(config.apiBase + '/users/:userId/avatar');
}

angular.module('dokiv')
  .factory('UserAvatarService', ['$resource', 'config', UserAvatarService]);





//////////////////
// WEBPACK FOOTER
// ./scripts/user/UserAvatarService.js
// module id = 437
// module chunks = 0